import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';

@Component({
  selector: 'app-rating-preview',
  templateUrl: './rating-preview.component.html',
  styleUrls: ['./rating-preview.component.scss']
,  standalone: false
})
export class RatingPreViewComponent implements OnInit {
  @Input() ratingConfig: RatingResponse;
  @Output() updateConfig = new EventEmitter<RatingResponse>();
  @Input() isEditing = false;

  getNumbers: number = 10;


  ngOnInit() {
    //This blank function is mandatory.
  }

  emitUpdatedData() {
    this.updateConfig.emit(this.ratingConfig);
  }

  updateValue(val) {
  
    this.ratingConfig.rating = val;
    this.updateConfig.emit(this.ratingConfig);
  }
}

export class RatingResponse {
  initialText?: string;
  finalText?: string;
  rating?: number;
}
